/**
 * Halaman FAQ (page-templates/template-faq.php) - switching tab kategori di
 * sidebar kiri. Accordion pertanyaan/jawaban di tiap panel sudah ditangani
 * accordion-js lewat initFaqAccordions() (./accordions.js); modul ini cuma
 * urusan tab-nya.
 *
 * Semua panel (termasuk yang tidak aktif) tetap di-render accordion-js-nya
 * sejak page load - lihat initFaqAccordions(), dipanggil terpisah dari sini
 * lewat initAccordions() di main.js. Panel yang belum aktif memang disembunyikan
 * lewat atribut `hidden` bawaan HTML (di-render begitu oleh PHP), bukan lewat
 * class CSS, supaya kontennya benar-benar tersembunyi dari screen reader tanpa
 * bergantung pada CSS ikut termuat.
 *
 * Tab-nya <a href="#slug"> asli (bukan <button>, lihat template) supaya
 * kategori bisa dibuka langsung lewat URL, mis. /faq#pengiriman - klik tab
 * mengubah location.hash secara native, dan event `hashchange` di bawah ini
 * satu-satunya sumber kebenaran untuk buka/tutup panelnya, jadi klik tab,
 * link eksternal ke URL ber-hash, maupun tombol back/forward browser semua
 * ditangani lewat jalur yang sama.
 */

export function initFaqPage() {
  const nav = document.querySelector(".dufeng-faq__nav-list");
  if (!nav) return;

  const tabs = Array.from(nav.querySelectorAll("[data-faq-target]"));
  const panels = Array.from(document.querySelectorAll("[data-faq-panel]"));
  if (!tabs.length || !panels.length) return;

  function activate(target) {
    tabs.forEach((tab) => {
      const isActive = tab.dataset.faqTarget === target;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.faqPanel === target;
      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
    });
  }

  function activateFromHash() {
    const target = decodeURIComponent(window.location.hash.replace(/^#/, ""));
    if (!target) return;

    const match = tabs.some((tab) => tab.dataset.faqTarget === target);
    if (match) activate(target);
  }

  activateFromHash();
  window.addEventListener("hashchange", activateFromHash);
}
